export function EndPoint() {
    return `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14" cy="14" r="13" fill="#08B549" stroke="white" stroke-width="2"/>
            <path d="M18.6 11L12 17.6L9 14.6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;
}
